'use client';

import { Box, Typography } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import { useState, useEffect } from 'react';

import ContentContainer from './Container';

import { PATH } from '@/shared/constants';
import { Image } from '@/shared/Components';

const Loading = () => {
  const [count, setCount] = useState(30);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [count]);

  return (
    <ContentContainer className="gap-1 pb-0 desktop:pb-0">
      <Box
        className={twJoin('flex flex-col items-center gap-1', 'desktop:gap-2')}
      >
        <Typography variant="body1" className="font-bold text-w-gray-900">
          요고가 꾹꾹 점치는 중
        </Typography>
        <Typography variant="body2" className="text-w-gray-600">
          {count}초
        </Typography>
      </Box>
      <Image
        src={`${PATH.MEDIA_YOZM_IMAGE}/fortune_yogocat_loading.gif`}
        width={152}
        height={72}
        className="h-[72px] w-[152px]"
        alt="로딩 운세 요고"
      />
    </ContentContainer>
  );
};

export default Loading;
